import type hr from './hr';
import type { DeepString } from '../types';

const en: DeepString<typeof hr> = {
  meta: {
    siteName: 'Soul Training',
    tagline: 'Online fitness and nutrition coaching',
  },
  nav: {
    home: 'Home',
    about: 'About',
    online: 'Online training',
    gym: 'In-person training',
    pricing: 'Pricing',
    results: 'Results',
    faq: 'FAQ',
    contact: 'Contact',
    login: 'Log in',
    cta: 'Free assessment',
  },
  common: {
    loading: 'Loading…',
    retry: 'Try again',
    cancel: 'Cancel',
    save: 'Save',
    back: 'Back',
    next: 'Next',
    close: 'Close',
    required: 'Required field',
  },
  empty: {
    noWorkoutToday: 'Today is a rest day. Recovery is part of progress.',
    noMeasurements: 'Add your first measurement and progress starts to show.',
    noMeals: 'Your food log is empty. Add your first meal.',
    noPhotos: 'Take your first progress photo and start the visual record.',
    noMessages: 'No messages yet. Reach out to your coach any time.',
    noClients: 'No clients yet. Anyone who buys a package will show up here.',
    noPrograms: 'No programs yet. Build your first one in the program builder.',
  },
  error: {
    generic: 'Something went wrong.',
    genericHelp: 'Try again. If it keeps happening, get in touch.',
    network: 'No internet connection.',
    networkHelp: 'Your data is saved on this device and will sync once you’re back online.',
    sessionExpired: 'Your session expired.',
    sessionExpiredHelp: 'Log in again to continue.',
    paymentFailed: 'Payment didn’t go through.',
    paymentFailedHelp: 'Check your card details or try another card.',
    // 402 — content behind a package. Not the same as a failed payment.
    contentLocked: 'This content is part of a paid program.',
    contentLockedHelp: 'Choose a package and the whole program unlocks.',
    subscriptionInactive: 'Your subscription is not active.',
    subscriptionInactiveHelp: 'Choose a package to unlock your program.',
    uploadFailed: 'Upload failed.',
    uploadFailedHelp: 'The photo is saved on your device. Try again.',
    syncFailed: 'Workout sync failed.',
    syncFailedHelp: '{count} entries waiting to sync. They’ll be sent automatically.',
    forbidden: 'You don’t have access to this content.',
    notFound: 'Page not found.',
  },
  auth: {
    login: 'Log in',
    register: 'Sign up',
    email: 'Email',
    password: 'Password',
    passwordConfirm: 'Confirm password',
    firstName: 'First name',
    lastName: 'Last name',
    forgot: 'Forgot your password?',
    submitLogin: 'Log in',
    submitRegister: 'Create account',
    verifySent: 'We sent you an email to confirm your address.',
    invalidCredentials: 'Wrong email or password.',
  },
  pricing: {
    title: 'Choose your program',
    popular: 'Most popular',
    buy: 'Get access',
    perMonth: 'per month',
    perQuarter: 'per quarter',
    oneTime: 'one-time',
    months: '{n} months',
    vatNote: 'Prices are final.',
  },
  checkout: {
    processing: 'Processing your payment…',
    processingHelp: 'This takes a few seconds. Please don’t close this page.',
    success: 'Payment confirmed.',
    successHelp: 'Your program is ready. Log in to the portal or download the app.',
  },
  portal: {
    dashboard: 'Home',
    training: 'Training',
    nutrition: 'Nutrition',
    progress: 'Progress',
    messages: 'Messages',
    profile: 'Profile',
    subscription: 'Subscription',
    todayWorkout: 'Today’s workout',
    startWorkout: 'Start workout',
    workoutComplete: 'Workout complete',
  },
};

export default en;
